import { StyleSheet } from "react-native";
import { webFont } from "../../../Universal/API/API";

export const createUnitFullV2Styles = (scaleAll: number) =>
  StyleSheet.create({
    main: {
      flex: 1,
      backgroundColor: "#FFFFFF",
    },
    scrollContent: {
      paddingTop: 12 * scaleAll,
      paddingBottom: 48 * scaleAll,
      paddingHorizontal: 16 * scaleAll,
    },
    shell: {
      width: "100%",
      maxWidth: 1480 * scaleAll,
      alignSelf: "center",
    },
    headerBlock: {
      marginBottom: 28 * scaleAll,
    },
    collectionChipPress: {
      alignSelf: "flex-start",
      cursor: "pointer",
    },
    collectionChip: {
      minHeight: 44 * scaleAll,
      borderRadius: 999,
      paddingHorizontal: 14 * scaleAll,
      paddingVertical: 7 * scaleAll,
      backgroundColor: "#111111",
      justifyContent: "center",
    },
    collectionChipText: {
      fontFamily: webFont("Inter"),
      fontSize: 13 * scaleAll,
      fontWeight: "700",
      color: "#FFFFFF",
      letterSpacing: 0.6,
      textTransform: "uppercase",
    },
    title: {
      fontFamily: webFont("Inter"),
      color: "#111111",
      fontWeight: "700",
      lineHeight: 50 * scaleAll,
      maxWidth: 1100 * scaleAll,
    },
    headerMetaRow: {
      marginTop: 18 * scaleAll,
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 10 * scaleAll,
    },
    inlineAction: {
      flexDirection: "row",
      alignItems: "center",
      minHeight: 44 * scaleAll,
      borderRadius: 999,
      paddingHorizontal: 14 * scaleAll,
      paddingVertical: 7 * scaleAll,
      borderWidth: 1,
      borderColor: "#E8E8E8",
      backgroundColor: "#FFFFFF",
      gap: 8 * scaleAll,
      cursor: "pointer",
    },
    inlineActionText: {
      fontFamily: webFont("Inter"),
      fontSize: 13 * scaleAll,
      color: "#101010",
      fontWeight: "600",
    },
    quickFactsWrap: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 10 * scaleAll,
      alignItems: "center",
    },
    quickFactChip: {
      minHeight: 44 * scaleAll,
      borderRadius: 999,
      paddingHorizontal: 14 * scaleAll,
      paddingVertical: 7 * scaleAll,
      backgroundColor: "#FFFFFF",
      borderWidth: 1,
      borderColor: "#ECECEC",
      justifyContent: "center",
    },
    quickFactText: {
      fontFamily: webFont("Inter"),
      fontSize: 13 * scaleAll,
      color: "#44413C",
      fontWeight: "500",
    },
    heroGrid: {
      alignItems: "flex-start",
    },
    heroGridWide: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    heroGridStack: {
      flexDirection: "column",
    },
    galleryColumn: {
      width: "100%",
    },
    infoColumn: {
      width: "100%",
      marginTop: 18 * scaleAll,
    },
    galleryCard: {
      width: "100%",
      backgroundColor: "#FFFFFF",
      borderRadius: 30 * scaleAll,
      paddingTop: 18 * scaleAll,
      paddingBottom: 14 * scaleAll,
      paddingHorizontal: 14 * scaleAll,
      borderWidth: 1,
      borderColor: "#ECECEC",
      shadowColor: "#000",
      shadowOpacity: 0.05,
      shadowRadius: 24,
      shadowOffset: { width: 0, height: 16 },
      elevation: 3,
      position: "relative",
    },
    galleryTopBar: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      marginBottom: 14 * scaleAll,
      paddingHorizontal: 6 * scaleAll,
      gap: 10 * scaleAll,
    },
    galleryTopBarText: {
      fontFamily: webFont("Inter"),
      fontSize: 13 * scaleAll,
      color: "#6F6F6F",
      fontWeight: "600",
      textTransform: "uppercase",
      letterSpacing: 0.8,
    },
    galleryExpandPill: {
      flexDirection: "row",
      alignItems: "center",
      borderRadius: 999,
      paddingHorizontal: 12 * scaleAll,
      paddingVertical: 8 * scaleAll,
      backgroundColor: "#F7F7F7",
      borderWidth: 1,
      borderColor: "#ECECEC",
      gap: 8 * scaleAll,
      cursor: "pointer",
    },
    galleryExpandPillText: {
      fontFamily: webFont("Inter"),
      fontSize: 13 * scaleAll,
      color: "#111111",
      fontWeight: "600",
    },
    galleryExpandPillSmall: {
      paddingHorizontal: 10 * scaleAll,
    },
    imageCounter: {
      position: "absolute",
      top: 62 * scaleAll,
      right: 24 * scaleAll,
      zIndex: 2,
      borderRadius: 999,
      backgroundColor: "rgba(17,17,17,0.9)",
      paddingHorizontal: 10 * scaleAll,
      paddingVertical: 6 * scaleAll,
    },
    imageCounterText: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      fontWeight: "600",
      color: "#FFFFFF",
    },
    emptyGallery: {
      width: "100%",
      minHeight: 320 * scaleAll,
      alignItems: "center",
      justifyContent: "center",
    },
    emptyGalleryText: {
      fontFamily: webFont("Inter"),
      fontSize: 16 * scaleAll,
      color: "#6C665D",
    },
    thumbRailScroll: {
      marginTop: 18 * scaleAll,
    },
    thumbRail: {
      paddingHorizontal: 2 * scaleAll,
      paddingBottom: 2 * scaleAll,
    },
    thumbCardPress: {
      marginRight: 10 * scaleAll,
      borderRadius: 20 * scaleAll,
      padding: 4 * scaleAll,
      cursor: "pointer",
    },
    thumbCardPressActive: {
    },
    thumbCardOverlay: {
      ...StyleSheet.absoluteFillObject,
      borderRadius: 16 * scaleAll,
      borderWidth: 2,
      borderColor: "#111111",
      backgroundColor: "transparent",
    },
    thumbCardOverlayActive: {
    },
    thumbCard: {
      width: 96 * scaleAll,
      height: 78 * scaleAll,
      borderRadius: 16 * scaleAll,
      overflow: "hidden",
      backgroundColor: "#FFFFFF",
    },
    thumbCardSmall: {
      width: 74 * scaleAll,
      height: 58 * scaleAll,
      borderRadius: 14 * scaleAll,
    },
    thumbImage: {
      width: "100%",
      height: "100%",
    },
    galleryFooterBar: {
      marginTop: 16 * scaleAll,
      paddingTop: 12 * scaleAll,
      borderTopWidth: 1,
      borderTopColor: "#F0F0F0",
      paddingHorizontal: 6 * scaleAll,
    },
    galleryFooterText: {
      fontFamily: webFont("Inter"),
      fontSize: 13 * scaleAll,
      lineHeight: 18 * scaleAll,
      color: "#707070",
    },
    galleryFooterTextSmall: {
      fontSize: 12 * scaleAll,
      lineHeight: 16 * scaleAll,
    },
    summaryCard: {
      width: "100%",
      backgroundColor: "#FFFFFF",
      borderRadius: 32 * scaleAll,
      padding: 24 * scaleAll,
      borderWidth: 1,
      borderColor: "#ECECEC",
      shadowColor: "#000",
      shadowOpacity: 0.05,
      shadowRadius: 24,
      shadowOffset: { width: 0, height: 14 },
      elevation: 3,
    },
    summaryCardSmall: {
      borderRadius: 24 * scaleAll,
      padding: 18 * scaleAll,
    },
    priceBlock: {
      marginBottom: 20 * scaleAll,
    },
    sectionEyebrow: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "#7A7A7A",
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: 1,
      marginBottom: 8 * scaleAll,
    },
    priceValue: {
      fontFamily: webFont("Inter"),
      fontSize: 30 * scaleAll,
      lineHeight: 34 * scaleAll,
      color: "#111111",
      fontWeight: "700",
    },
    sectionBlock: {
      marginBottom: 20 * scaleAll,
    },
    sectionHeaderRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "baseline",
      gap: 10 * scaleAll,
      marginBottom: 8 * scaleAll,
    },
    sectionHeaderValue: {
      fontFamily: webFont("Inter"),
      fontSize: 15 * scaleAll,
      color: "#111111",
      fontWeight: "600",
    },
    swatchRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 12 * scaleAll,
      overflow: "visible",
    },
    swatchItem: {
      position: "relative",
      alignItems: "center",
      justifyContent: "center",
      overflow: "visible",
    },
    swatchItemPressable: {
      cursor: "pointer",
    },
    swatchItemSmall: {
      marginRight: 0,
    },
    swatchItemActive: {
      opacity: 1,
    },
    swatchCircle: {
      width: 42 * scaleAll,
      height: 42 * scaleAll,
      borderRadius: 999,
      borderWidth: 1.5,
      // opacity:
      marginBottom: 8 * scaleAll,
    },
    swatchCircleActive: {
      borderWidth: 2.5,
    },
    swatchCircleSmall: {
      width: 36 * scaleAll,
      height: 36 * scaleAll,
    },
    swatchTooltipWrap: {
      position: "absolute",
      bottom: 52 * scaleAll,
      left: -56 * scaleAll,
      right: -56 * scaleAll,
      alignItems: "center",
      zIndex: 4,
    },
    swatchTooltip: {
      borderRadius: 999,
      paddingHorizontal: 10 * scaleAll,
      paddingVertical: 6 * scaleAll,
      backgroundColor: "#111111",
      shadowColor: "#000",
      shadowOpacity: 0.12,
      shadowRadius: 12,
      shadowOffset: { width: 0, height: 6 },
      elevation: 3,
    },
    swatchTooltipText: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "#FFFFFF",
      fontWeight: "600",
      textAlign: "center",
    },
    variantChipRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 10 * scaleAll,
    },
    variantChip: {
      minHeight: 42 * scaleAll,
      borderRadius: 999,
      paddingHorizontal: 14 * scaleAll,
      paddingVertical: 10 * scaleAll,
      backgroundColor: "#FFFFFF",
      borderWidth: 1,
      borderColor: "#E6E6E6",
      justifyContent: "center",
      cursor: "pointer",
    },
    variantChipSmall: {
      minHeight: 36 * scaleAll,
      paddingHorizontal: 12 * scaleAll,
      paddingVertical: 8 * scaleAll,
    },
    variantChipActive: {
      backgroundColor: "#111111",
      borderColor: "#111111",
    },
    variantChipLabel: {
      fontFamily: webFont("Inter"),
      fontSize: 13 * scaleAll,
      color: "#2F2F2F",
      fontWeight: "600",
    },
    variantChipLabelActive: {
      color: "#FFFFFF",
    },
    stockCardWrap: {
      borderRadius: 24 * scaleAll,
      overflow: "hidden",
      borderWidth: 1,
      borderColor: "#EFEFEF",
      backgroundColor: "#FFFFFF",
    },
    actionColumn: {
      gap: 12 * scaleAll,
    },
    cartSummaryAddButton: {
      width: "100%",
      borderRadius: 24 * scaleAll,
      backgroundColor: "#111111",
      paddingHorizontal: 18 * scaleAll,
      paddingVertical: 16 * scaleAll,
      cursor: "pointer",
    },
    cartSummaryAddButtonLabel: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "rgba(255,255,255,0.66)",
      fontWeight: "600",
      textTransform: "uppercase",
      letterSpacing: 0.8,
      marginBottom: 6 * scaleAll,
    },
    cartSummaryAddButtonValue: {
      fontFamily: webFont("Inter"),
      fontSize: 18 * scaleAll,
      color: "#FFFFFF",
      fontWeight: "700",
    },
    cartSummaryCard: {
      width: "100%",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      borderRadius: 24 * scaleAll,
      backgroundColor: "#FAFAFA",
      borderWidth: 1,
      borderColor: "#EAEAEA",
      paddingHorizontal: 16 * scaleAll,
      paddingVertical: 14 * scaleAll,
    },
    cartSummaryMeta: {
      flex: 1,
      paddingRight: 12 * scaleAll,
    },
    cartSummaryTitle: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "#7A746C",
      fontWeight: "600",
      textTransform: "uppercase",
      letterSpacing: 0.7,
      marginBottom: 5 * scaleAll,
    },
    cartSummaryValue: {
      fontFamily: webFont("Inter"),
      fontSize: 18 * scaleAll,
      color: "#111111",
      fontWeight: "700",
    },
    cartSummaryActions: {
      flexDirection: "row",
      alignItems: "center",
      gap: 8 * scaleAll,
    },
    cartSummaryGhostButton: {
      width: 40 * scaleAll,
      height: 40 * scaleAll,
      borderRadius: 14 * scaleAll,
      borderWidth: 1,
      borderColor: "#E2E2E2",
      backgroundColor: "#FFFFFF",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    cartSummaryGhostButtonText: {
      fontFamily: webFont("Inter"),
      fontSize: 22 * scaleAll,
      lineHeight: 24 * scaleAll,
      color: "#101010",
      fontWeight: "700",
    },
    cartSummaryPrimaryButton: {
      width: 40 * scaleAll,
      height: 40 * scaleAll,
      borderRadius: 14 * scaleAll,
      backgroundColor: "#111111",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    cartSummaryPrimaryButtonText: {
      fontFamily: webFont("Inter"),
      fontSize: 22 * scaleAll,
      lineHeight: 24 * scaleAll,
      color: "#FFFFFF",
      fontWeight: "700",
    },
    actionButtonPress: {
      width: "100%",
      cursor: "pointer",
    },
    actionButton: {
      borderRadius: 24 * scaleAll,
      backgroundColor: "#111111",
      paddingHorizontal: 18 * scaleAll,
      paddingVertical: 16 * scaleAll,
    },
    actionButtonLabel: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "rgba(255,255,255,0.66)",
      fontWeight: "600",
      textTransform: "uppercase",
      letterSpacing: 0.8,
      marginBottom: 6 * scaleAll,
    },
    actionButtonValue: {
      fontFamily: webFont("Inter"),
      fontSize: 18 * scaleAll,
      color: "#FFFFFF",
      fontWeight: "700",
    },
    copyCard: {
      width: "100%",
      flexDirection: "row",
      alignItems: "center",
      borderRadius: 24 * scaleAll,
      backgroundColor: "#FAFAFA",
      borderWidth: 1,
      borderColor: "#EAEAEA",
      padding: 16 * scaleAll,
      cursor: "pointer",
    },
    copyIconBox: {
      width: 40 * scaleAll,
      height: 40 * scaleAll,
      borderRadius: 14 * scaleAll,
      backgroundColor: "#F1F1F1",
      alignItems: "center",
      justifyContent: "center",
      marginRight: 12 * scaleAll,
    },
    copyTextWrap: {
      flex: 1,
    },
    copyTitle: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "#7A746C",
      fontWeight: "600",
      textTransform: "uppercase",
      letterSpacing: 0.7,
      marginBottom: 5 * scaleAll,
    },
    copyValue: {
      fontFamily: webFont("Inter"),
      fontSize: 17 * scaleAll,
      color: "#111111",
      fontWeight: "700",
    },
    descriptionCard: {
      marginTop: 28 * scaleAll,
      borderRadius: 32 * scaleAll,
      backgroundColor: "#FFFFFF",
      borderWidth: 1,
      borderColor: "#ECECEC",
      overflow: "hidden",
      shadowColor: "#000",
      shadowOpacity: 0.05,
      shadowRadius: 18,
      shadowOffset: { width: 0, height: 12 },
      elevation: 2,
    },
    descriptionHeader: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#F7F7F7",
      paddingHorizontal: 22 * scaleAll,
      paddingVertical: 20 * scaleAll,
      cursor: "pointer",
    },
    descriptionTitle: {
      fontFamily: webFont("Inter"),
      fontSize: 22 * scaleAll,
      color: "#111111",
      fontWeight: "700",
    },
    descriptionBodyAnimatedWrap: {
      overflow: "hidden",
    },
    descriptionBody: {
      flexDirection: "row",
      alignItems: "stretch",
      padding: 22 * scaleAll,
      gap: 28 * scaleAll,
    },
    descriptionBodySmall: {
      flexDirection: "column",
    },
    descriptionContent: {
      flex: 1,
    },
    descriptionCountryRow: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 20 * scaleAll,
      gap: 12 * scaleAll,
    },
    descriptionCountryFlag: {
      width: 42 * scaleAll,
      height: 42 * scaleAll,
      borderRadius: 12 * scaleAll,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#FAFAFA",
      borderWidth: 1,
      borderColor: "#E8E8E8",
      overflow: "hidden",
    },
    descriptionCountryLabel: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "#7A746C",
      fontWeight: "600",
      textTransform: "uppercase",
      letterSpacing: 0.7,
      marginBottom: 3 * scaleAll,
    },
    descriptionCountryValue: {
      fontFamily: webFont("Inter"),
      fontSize: 17 * scaleAll,
      color: "#111111",
      fontWeight: "700",
    },
    descriptionText: {
      fontFamily: webFont("Inter"),
      fontSize: 16 * scaleAll,
      lineHeight: 25 * scaleAll,
      color: "#49443E",
      fontWeight: "500",
    },
    descriptionImageWrap: {
      width: 360 * scaleAll,
      minHeight: 300 * scaleAll,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 24 * scaleAll,
      backgroundColor: "#FAFAFA",
      borderWidth: 1,
      borderColor: "#F0F0F0",
      overflow: "hidden",
    },
    descriptionImage: {
      width: "100%",
      height: "100%",
    },
    techCard: {
      marginTop: 28 * scaleAll,
      borderRadius: 32 * scaleAll,
      backgroundColor: "#FFFFFF",
      borderWidth: 1,
      borderColor: "#ECECEC",
      overflow: "hidden",
      shadowColor: "#000",
      shadowOpacity: 0.05,
      shadowRadius: 18,
      shadowOffset: { width: 0, height: 12 },
      elevation: 2,
    },
    techHeader: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#F7F7F7",
      paddingHorizontal: 22 * scaleAll,
      paddingVertical: 20 * scaleAll,
      cursor: "pointer",
    },
    techTitle: {
      fontFamily: webFont("Inter"),
      fontSize: 22 * scaleAll,
      color: "#111111",
      fontWeight: "700",
    },
    techBody: {
      paddingHorizontal: 0,
    },
    techBodyAnimatedWrap: {
      overflow: "hidden",
    },
    specRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      paddingHorizontal: 22 * scaleAll,
      paddingVertical: 18 * scaleAll,
      borderBottomWidth: 1,
      borderBottomColor: "#EFEFEF",
      minHeight: 68 * scaleAll,
    },
    specRowAlt: {
      backgroundColor: "#FCFCFC",
    },
    specRowStack: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
    specRowLast: {
      borderBottomWidth: 0,
    },
    specLabel: {
      fontFamily: webFont("Inter"),
      fontSize: 16 * scaleAll,
      color: "#49443E",
      fontWeight: "500",
      flexShrink: 1,
      marginRight: 18 * scaleAll,
      marginBottom: 4 * scaleAll,
    },
    specValueWrap: {
      maxWidth: "55%",
      alignItems: "flex-end",
    },
    specValueWrapStack: {
      maxWidth: "100%",
      width: "100%",
      alignItems: "flex-start",
    },
    specValue: {
      fontFamily: webFont("Inter"),
      fontSize: 16 * scaleAll,
      color: "#111111",
      fontWeight: "600",
      textAlign: "right",
    },
    specLink: {
      color: "#0A84FF",
      cursor: "pointer",
    },
  });

export type UnitFullV2Styles = ReturnType<typeof createUnitFullV2Styles>;
